import { Layout } from 'components';
import { NoAccessPage } from 'pages/NoAccess';
import React, { useEffect } from 'react';
import { Route, useHistory } from 'react-router-dom';
import { ROUTES } from 'shared/constants/ROUTES';
import { authService } from 'shared/services/authService';

type Props = {
  component: React.FC;
  exact?: boolean;
  path: string | string[];
  access?: string;
};
const { getProfile } = authService();

const AdminRoute: React.FC<Props> = ({ component: Component, path, exact, access }) => {
  const current_user_role: string[] =
    localStorage.getItem('user_roles') === undefined || localStorage.getItem('user_roles') === null
      ? []
      : JSON.parse(localStorage.getItem('user_roles') || '');

  const profile = getProfile();
  const history = useHistory();
  useEffect(() => {
    if (!profile) {
      history.push(ROUTES.LOGIN);
    }
  }, [profile, history]);

  return (
    <Layout>
      {current_user_role.includes(access ?? '') ? (
        <Route path={path} exact={exact} render={() => <Component />} />
      ) : (
        <NoAccessPage />
      )}
      {/* <Route path={path} exact={exact} render={() => <Component />} /> */}
    </Layout>
  );
};

export default AdminRoute;
